module.exports = {"id":"125871","name":"Hasan Ali Kaldırım","rating":"74","photo":"./data/images/photos/4/125871.png","club":{"name":"Fenerbahçe","logo":"./data/images/clubs/Fenerbahce.png"},"positions":["DG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HasanAliKaldırım0.json
// module id = 1704
// module chunks = 0